import PropTypes from 'prop-types';
import { useEffect, useRef } from 'preact/hooks';

import CoreHeader from '@distinct-components/navigation/coreHeader';
import CoreSideNav from '@distinct-components/navigation/coreSideNav/CoreSideNav';
import {
  CoreWrapper,
  CorePageWrapper,
  CoreAlertWrapper,
  MockAlert,
  CoreHeaderWrapper,
  CoreWorkSpaceWrapper,
  CoreContentWrapper,
} from './CoreLayoutStyles';

const childrenPropTypes = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.func,
  PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ])),
]);

function CoreLayout({
  children,
  globalAlert,
}) {
  const topRef = useRef();
  useEffect(() => {
    topRef.current.scrollIntoView();
    document.body.style.backgroundColor = 'var(--background)';
  }, []);

  return (
    <CoreWrapper>
      <CorePageWrapper ref={topRef}>
        {globalAlert
        && (
        <CoreAlertWrapper>
          <MockAlert>{globalAlert}</MockAlert>
        </CoreAlertWrapper>
        )}
        <CoreHeaderWrapper globalAlert={globalAlert}>
          <CoreHeader />
        </CoreHeaderWrapper>
        <CoreWorkSpaceWrapper>
          <CoreSideNav mode="artist" globalAlert={globalAlert} />
          <CoreContentWrapper>
            {children}
          </CoreContentWrapper>
        </CoreWorkSpaceWrapper>
      </CorePageWrapper>
    </CoreWrapper>
  );
}

CoreLayout.propTypes = {
  children: childrenPropTypes.isRequired,
  globalAlert: PropTypes.string,
};

CoreLayout.defaultProps = {
  globalAlert: null,
};

export default CoreLayout;
